module.exports = {
  login: 'Login',
  username: {
    heading: 'Username',
    required: 'Please enter your username.'
  },
  password: {
    heading: 'Password',
    required: 'Please enter your password.'
  },
  country: {
    heading: 'Country',
    required: 'Please select a country',
    uk: 'UK',
    spain: 'Spain',
    italy: 'Italy',
    portugal: 'Portugal',
    denmark: 'Denmark',
    sweden: 'Sweden',
    netherlands: 'Netherlands'
  },
  language: {
    heading: 'Language',
    required: 'Please select a language',
    english: 'English',
    spanish: 'Spanish',
    italian: 'Italian',
    portugese: 'Portugese',
    danish: 'Danish',
    swedish: 'Swedish',
    dutch: 'Dutch'
  },
  remember_me: 'remember me',
  failure: 'The username / password you have entered is not valid. Please try again.',
  invalidPassword: 'For security reasons passwords can not include the following word(s) : {invalidPasswordWords}. Please click here to update your password.',
  reset_password: 'reset password'
}



//////////////////
// WEBPACK FOOTER
// ./src/plugins/localisation/languages/pt/login.js
// module id = /0Xd
// module chunks = 1